import { render, staticRenderFns } from "./MyStudies.vue?vue&type=template&id=6c8741f1&scoped=true&"
import script from "./MyStudies.vue?vue&type=script&lang=js&"
export * from "./MyStudies.vue?vue&type=script&lang=js&"
import style0 from "./MyStudies.vue?vue&type=style&index=0&id=6c8741f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8741f1",
  null
  
)

export default component.exports